import React, { Fragment } from 'react';
import { priceFormatter } from '../../../../helpers/formatters';
import { isMobile } from '../../../../helpers/device';
import useBasketSize from '../../../../hooks/useBasketSize';
import useTranslate from '../../../../hooks/useTranslate';
import Messager from '../../../../lib/messager';
import Button from '../../Button';
import CurrencyIcon from '../../../../shared/components/Icons/Currency';
import Table from '../../../../shared/components/Table';
import SectorCounter from './counter';
import Styled from './styles';
import MESSAGE_TYPES from '../../../../constants/MESSAGE_TYPES';
import Currency from '../../../../shared/components/Currency';
import { ICategory } from '../../../../types/category';
import type { ITicketsControllerSector } from '../../../../types/sector';

interface SectorsTableProps {
  onSelect: (sector: any) => void;
  sectors: ITicketsControllerSector[];
  categories: ICategory[];
}

const SectorsTable = ({ onSelect, sectors = [], categories = [] }: SectorsTableProps) => {
  const { Widget } = window;
  const { t, transliterate } = useTranslate();
  const mobile = isMobile();
  const basketSize = useBasketSize();

  return (
    <Styled.TableWrapper offset={basketSize}>
      <Table>
        {(!categories.length || Widget.isHybrid) &&
          sectors.map((sector, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <tr key={index}>
              <td>
                {transliterate(sector.label)}
                {mobile && (
                  <Fragment>
                    <Styled.MobileCount>
                      {sector.ticketsCount} {t('pcs')}
                    </Styled.MobileCount>
                    {sector.data && !sector.data.rows.length && (
                      <Styled.StyledCurrency>
                        {priceFormatter(sector.price)} <CurrencyIcon height={11} width={11} />
                      </Styled.StyledCurrency>
                    )}
                  </Fragment>
                )}
              </td>
              {!mobile && (
                <Fragment>
                  <td>
                    {sector.ticketsCount} {t('pcs')}
                  </td>
                  <Styled.PriceColumn>
                    {t('from_price')}{' '}
                    <Currency>
                      {priceFormatter(sector.minPrice)} <CurrencyIcon height={11} width={11} />
                    </Currency>
                  </Styled.PriceColumn>
                </Fragment>
              )}

              <td>
                <Styled.CellInner>
                  {sector.data && sector.data.rows.length ? (
                    <Button
                      compact
                      onClick={() => {
                        Messager.send({
                          type: MESSAGE_TYPES.ON_TABLE_SECTOR_SELECTED,
                          sector: sector.label,
                        });
                        onSelect(sector);
                      }}
                    >
                      {mobile ? (
                        <Fragment>
                          {t('from_price')}{' '}
                          <Currency>
                            {priceFormatter(sector.minPrice)}
                            <CurrencyIcon fill="#fff" height={10} width={15} />
                          </Currency>
                        </Fragment>
                      ) : (
                        t('selectTickets')
                      )}
                    </Button>
                  ) : (
                    <SectorCounter data={sector} />
                  )}
                </Styled.CellInner>
              </td>
            </tr>
          ))}

        {categories.map((category, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <tr key={index}>
            <td>
              {transliterate(category.label)}
              {mobile && (
                <Fragment>
                  <Styled.MobileCount>
                    {category.count} {t('pcs')}
                  </Styled.MobileCount>
                  <Styled.StyledCurrency>
                    {priceFormatter(category.price)} <CurrencyIcon height={11} width={11} />
                  </Styled.StyledCurrency>
                </Fragment>
              )}
            </td>
            {!mobile && (
              <Fragment>
                <td>
                  {category.count} {t('pcs')}
                </td>
                <Styled.PriceColumn>
                  {t('from_price')}{' '}
                  <Currency>
                    {priceFormatter(category.price)} <CurrencyIcon height={11} width={11} />
                  </Currency>
                </Styled.PriceColumn>
              </Fragment>
            )}

            <td>
              <Styled.CellInner>
                <SectorCounter data={category} isCategory={true} />
              </Styled.CellInner>
            </td>
          </tr>
        ))}
      </Table>
    </Styled.TableWrapper>
  );
};

export default SectorsTable;
